import { render, staticRenderFns } from "./PINSetting.vue?vue&type=template&id=2e45a70f&"
import script from "./PINSetting.vue?vue&type=script&lang=js&"
export * from "./PINSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports